import React from 'react';

const TECH_CONFIG = {
  SF: {
    label: 'Salesforce',
    color: '#00A1E0',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 flex-shrink-0">
        <path d="M10.006 5.17a4.015 4.015 0 0 1 3.084-1.456c1.533 0 2.893.87 3.567 2.143a4.715 4.715 0 0 1 1.899-.398c2.63 0 4.762 2.148 4.762 4.798S21.187 15.055 18.556 15.055c-.387 0-.764-.047-1.124-.135a3.653 3.653 0 0 1-3.205 1.903c-.468 0-.915-.089-1.326-.25a4.243 4.243 0 0 1-3.893 2.57c-1.815 0-3.376-1.14-3.985-2.743a3.743 3.743 0 0 1-.88.106c-2.07 0-3.749-1.691-3.749-3.776 0-1.31.665-2.464 1.675-3.143A3.906 3.906 0 0 1 1.73 7.841c0-2.166 1.744-3.922 3.895-3.922a3.87 3.87 0 0 1 3.004 1.427l.002-.002.375-.174z"/>
      </svg>
    ),
  },
  Java: {
    label: 'Java',
    color: '#E76F00',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 flex-shrink-0">
        <path d="M8.851 18.56s-.917.534.653.714c1.902.218 2.874.187 4.969-.211 0 0 .552.346 1.321.646-4.699 2.013-10.633-.118-6.943-1.149m-.575-2.627s-1.028.761.542.924c2.032.209 3.636.227 6.413-.308 0 0 .384.389.987.602-5.679 1.661-12.007.13-7.942-1.218m4.84-4.458c1.158 1.333-.304 2.533-.304 2.533s2.939-1.518 1.589-3.418c-1.261-1.772-2.228-2.652 3.007-5.688 0 0-8.216 2.051-4.292 6.573m6.592 9.608s.679.559-.747.992c-2.712.822-11.288 1.069-13.669.033-.856-.373.75-.89 1.254-.998.527-.114.828-.093.828-.093-.953-.671-6.156 1.317-2.643 1.887 9.58 1.553 17.462-.7 14.977-1.821M9.292 13.21s-4.362 1.036-1.544 1.412c1.189.159 3.561.123 5.77-.062 1.806-.152 3.618-.477 3.618-.477s-.637.272-1.098.587c-4.429 1.165-12.986.623-10.522-.569 2.082-1.006 3.776-.891 3.776-.891m7.824 4.374c4.503-2.34 2.421-4.589.968-4.285-.355.074-.515.138-.515.138s.132-.207.385-.297c2.875-1.011 5.086 2.981-.928 4.562 0 0 .07-.062.09-.118M14.401 0s2.494 2.494-2.365 6.33c-3.896 3.077-.889 4.832 0 6.836-2.274-2.053-3.943-3.858-2.824-5.54 1.644-2.469 6.197-3.665 5.189-7.626"/>
      </svg>
    ),
  },
  NodeJS: {
    label: 'Node.js',
    color: '#339933',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 flex-shrink-0">
        <path d="M11.998 24c-.321 0-.641-.084-.922-.247l-2.936-1.737c-.438-.245-.224-.332-.08-.383.585-.203.703-.25 1.328-.604.065-.037.151-.023.218.017l2.256 1.339a.29.29 0 0 0 .272 0l8.795-5.076a.277.277 0 0 0 .134-.238V6.921a.28.28 0 0 0-.137-.242l-8.791-5.072a.278.278 0 0 0-.271 0L3.075 6.68a.28.28 0 0 0-.139.24v10.15a.27.27 0 0 0 .137.236l2.409 1.392c1.307.654 2.108-.116 2.108-.89V7.787c0-.142.114-.253.256-.253h1.115c.139 0 .255.112.255.253v10.021c0 1.745-.95 2.745-2.604 2.745-.509 0-.909 0-2.026-.551L2.28 18.675a1.857 1.857 0 0 1-.922-1.604V6.921c0-.659.353-1.275.922-1.603L11.076.242a1.92 1.92 0 0 1 1.846 0l8.794 5.076c.57.329.924.944.924 1.603v10.15a1.86 1.86 0 0 1-.924 1.604l-8.794 5.078a1.836 1.836 0 0 1-.924.247z"/>
      </svg>
    ),
  },
  Swift: {
    label: 'Swift',
    color: '#F05138',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 flex-shrink-0">
        <path d="M16.938 4.956c2.007 4.27-.07 9.084-4.092 11.89 3.06-1.725 5.094-4.27 5.94-6.814.846-2.543.47-4.682-.27-6.116-.148-.286-.42-.57-.72-.81a9.585 9.585 0 0 0-.858.85zM12.483 16.5c-.63.343-1.302.62-2.002.833C6.768 18.672 3.178 17.42 1.51 14.82c1.986 3.075 5.697 4.296 8.79 3.3.534-.17 1.049-.395 1.537-.666a9.17 9.17 0 0 0 .646-.954zM21.6 8.4c.72 3.78-.54 7.44-3.06 9.96-1.62 1.62-3.78 2.82-6.3 3.24-.36.06-.72.06-1.08.06-2.22 0-4.32-.72-6.06-2.04 2.82 2.4 7.08 3.06 10.62 1.08 2.46-1.38 4.26-3.78 4.98-6.6.36-1.44.48-2.94.18-4.44a7.23 7.23 0 0 0-.78-2.34c.3.36.42.72.5 1.08zM15.78 7.38c-2.76-2.64-6.6-4.2-8.82-3.3 3.12-.84 6.72.72 9 3.12a8.29 8.29 0 0 1 2.16 4.92c-.24-1.8-1.02-3.42-2.34-4.74z"/>
      </svg>
    ),
  },
};

const DEFAULT_CONFIG = {
  label: '',
  color: '#6B7280',
  icon: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5 flex-shrink-0">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
    </svg>
  ),
};

export const getTechConfig = (projectType) => {
  if (!projectType) return null;
  const config = TECH_CONFIG[projectType];
  if (config) return config;
  return { ...DEFAULT_CONFIG, label: projectType };
};

export const TECH_TYPES = Object.keys(TECH_CONFIG);

const TechBadge = ({ projectType }) => {
  const config = getTechConfig(projectType);
  if (!config) return null;

  return (
    <span
      className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold"
      style={{
        color: config.color,
        backgroundColor: `${config.color}18`,
        border: `1px solid ${config.color}30`,
      }}
    >
      {config.label}
    </span>
  );
};

export default TechBadge;
